import { SvgIcon, SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

export interface MiteneIconProps extends SvgIconProps {
  readonly size?: 20 | 24 | 36 | 48 | 80
}

export const MiteneIconBase = forwardRef<SVGSVGElement, MiteneIconProps>(
  (props, ref) => {
    const { size = 24, children, ...other } = props;

    const style = {
      width: size,
      height: size,
    };

    return (
      <SvgIcon ref={ref} style={style} {...other}>
        {children}
      </SvgIcon>
    );
  }
);
